const initialState = {
  orderListResult: [],
  orderListState: null,
  orderTypeList: [],
};

// 订单列表
export default function receiveOrderListResult(state = initialState, action) {
  switch (action.type) {
  case 'SHOW_ORDER_lIST':
    return { ...state, orderListResult: action.payload };
  case 'SHOW_ORDER_MENU_lIST':
    return { ...state, orderTypeList: action.payload };
  case 'SAVE_ORDER_LIST_STATE':
    return { ...state, orderListState: action.payload };
  case 'CLEAR_ORDER_LIST_STATE':
    return { ...state, orderListState: null };
  default:
    return state;
  }
}